<template>
  <section class="editor-entities">
    <h1>Contenus</h1>

    <el-row :gutter="10">
      <el-col :xs="24" :md="12" :lg="6" v-for="entity in entities" :key="entity.entityId">
        <router-link
          :to="{ name: 'editor-contents', params: { spaceId: $route.params.spaceId, entityId: entity.entityId} }" class="box">
          <img src="/images/page.svg" alt="">
          <span>{{ entity.name }}</span>
        </router-link>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'editor-entities',
  components: {
  },
  data() {
    return {
      entities: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.entities = await api.getEntities(this.$route.params.spaceId);
    },
  },
};
</script>

<style lang="sass">
.editor-entities
  .box
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    margin: 0.3rem 0
    padding: 2rem 1rem
    width: 100%
    background: #ffffff
    border-radius: 10px
    transition: all ease-in 0.2s
    &:hover
      background: lighten(#001861, 75%)
    & ~ .box
      margin-left: 1rem

    img
      display: block
      margin: 0 1rem 1.5rem
      height: 150px
    span
      font-weight: bold

</style>
